import styled from "styled-components";
import { palette, typography } from "@src/core/styles";

export const UuidList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${palette.colors.outline_variant};
`;

export const UuidRow = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid ${palette.colors.outline_variant};
  background-color: ${palette.colors.surface};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${palette.colors.surface_container};
  }
`;

export const UuidValue = styled.code`
  ${typography.body_medium_regular};
  font-family: "JetBrains Mono", "Fira Code", "Courier New", monospace;
  font-size: 13px;
  color: ${palette.colors.onsurface};
  flex: 1;
  word-break: break-all;
`;
